import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { TranslatorContext, useSafeTranslatedUrls } from '@jutro/locale';
import { intlMessageShape, intlToShape } from '@jutro/prop-types';
import styles from "./Breadcrumb.module.css";
import { messages } from './Breadcrumb.messages';
import { Link } from '../Link/Link';
const breadcrumbPropTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    text: intlMessageShape.isRequired,
    href: intlMessageShape,
    to: intlToShape,
    className: PropTypes.string
  })),
  theme: PropTypes.object,
  renderLinkTrigger: PropTypes.func,
  lastItemClickable: PropTypes.bool,
  backLinkWithoutText: PropTypes.bool
};
export const Breadcrumb = props => {
  const className = props.className,
    links = props.links,
    renderLinkTrigger = props.renderLinkTrigger,
    lastItemClickable = props.lastItemClickable,
    backLinkWithoutText = props.backLinkWithoutText;
  const translator = useContext(TranslatorContext);
  const urlTranslatorAndSanitizer = useSafeTranslatedUrls();
  if (!(links !== null && links !== void 0 && links.length)) {
    return null;
  }
  const breadcrumbClasses = cx(styles.breadcrumb, className);
  const divider = React.createElement("span", {
    "aria-hidden": "true",
    className: styles.divider
  }, "/");
  const defaultRenderLink = _ref => {
    let text = _ref.text,
      linkProps = _objectWithoutProperties(_ref, ["text"]);
    return React.createElement(Link, linkProps, text);
  };
  const renderLinkItem = renderLinkTrigger || defaultRenderLink;
  const renderReadOnlyItem = ({
    text
  }) => React.createElement("span", {
    className: styles.currentLink
  }, text);
  const breadcrumbs = _mapInstanceProperty(links).call(links, (_ref2, index, array) => {
    let linkClassName = _ref2.className,
      href = _ref2.href,
      to = _ref2.to,
      text = _ref2.text,
      linkProps = _objectWithoutProperties(_ref2, ["className", "href", "to", "text"]);
    const linkClasses = cx(styles.breadcrumbLink, linkClassName);
    const translatedText = translator(text);
    const isLastItem = array.length - 1 === index;
    const isReadOnly = isLastItem && !lastItemClickable;
    const ariaCurrent = isLastItem && lastItemClickable ? {
      'aria-current': 'page'
    } : {};
    return React.createElement(React.Fragment, {
      key: `breadcrumb_link_${index}`
    }, index > 0 && divider, isReadOnly ? renderReadOnlyItem({
      text: translatedText
    }) : renderLinkItem(_objectSpread({
      className: linkClasses,
      text: translatedText,
      href: href && urlTranslatorAndSanitizer(href),
      to: to && urlTranslatorAndSanitizer(to)
    }, ariaCurrent, {}, linkProps)));
  });
  const backLink = () => {
    const lastItem = links[links.length - 1];
    const isLastItemNotClickable = !lastItem.href && !lastItem.to || lastItemClickable === false;
    const item = isLastItemNotClickable ? links[0] : lastItem;
    const linkClassName = item.linkClassName,
      href = item.href,
      to = item.to;
    const linkClasses = cx(styles.breadcrumbLink, linkClassName);
    const label = translator(messages.breadcrumbBackButtonLabel);
    const translatedText = backLinkWithoutText ? '' : label;
    return React.createElement(React.Fragment, null, renderLinkItem(_objectSpread({
      icon: 'mi-keyboard-back',
      className: linkClasses,
      text: translatedText,
      href: href && urlTranslatorAndSanitizer(href),
      to: to && urlTranslatorAndSanitizer(to),
      'aria-label': label
    }, item.linkProps)));
  };
  return React.createElement("div", {
    className: breadcrumbClasses,
    "aria-label": translator(messages.breadcrumbLabel),
    role: "navigation"
  }, links.length >= 2 && breadcrumbs, links.length < 2 && backLink());
};
Breadcrumb.propTypes = breadcrumbPropTypes;
Breadcrumb.__docgenInfo = {
  componentName: "Breadcrumb",
  packageName: "@jutro/components",
  description: "Displays a \"breadcrumb\" of links to previous pages with anchor tags or Link components",
  displayName: "Breadcrumb",
  methods: [],
  actualName: "Breadcrumb",
  metadataType: "action",
  props: {
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "Additional class to wrap the component."
    },
    links: {
      type: {
        name: "arrayOf",
        value: {
          name: "shape",
          value: {
            text: {
              name: "union",
              required: true,
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: false
                  },
                  defaultMessage: {
                    name: "string",
                    required: false
                  },
                  args: {
                    name: "shape",
                    value: {},
                    required: false
                  }
                }
              }]
            },
            href: {
              name: "union",
              required: false,
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: false
                  },
                  defaultMessage: {
                    name: "string",
                    required: false
                  },
                  args: {
                    name: "shape",
                    value: {},
                    required: false
                  }
                }
              }]
            },
            to: {
              name: "custom",
              raw: "intlToShape",
              required: false
            },
            className: {
              name: "string",
              required: false
            }
          }
        }
      },
      required: false,
      description: "Takes an array of objects, each item having props for the used Link type component."
    },
    theme: {
      type: {
        name: "object"
      },
      required: false,
      description: "Theme config to apply."
    },
    renderLinkTrigger: {
      type: {
        name: "func"
      },
      required: false,
      description: "RenderProp function to generate the component that makes up the breadcrumb."
    },
    lastItemClickable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Determines if the last item is a link."
    },
    backLinkWithoutText: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Determines if the backLink include \"Back\" text or just \"arrow\" icon."
    }
  }
};